import React from "react";
import Contracts from "@/components/Pages/Public/Contracts";
const ContractsPage = () => {
  return <Contracts />;
};

export default ContractsPage;
